import React from 'react';
import { useTranslation } from 'react-i18next';
import CorrectionsDetailsTable from './content';
import { SimpleModal } from '@livable/saas-react-components';
const CorrectionsDetails = _ref => {
  let allocationCycleId = _ref.allocationCycleId,
    isOpenExternal = _ref.isOpenExternal,
    correctionSummary = _ref.correctionSummary,
    isExcluded = _ref.isExcluded,
    handleModalCloseExt = _ref.handleModalCloseExt;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(SimpleModal, {
    noFooter: true,
    noPadding: true,
    trigger: null,
    variant: 'large',
    isOpen: isOpenExternal,
    handleClose: handleModalCloseExt,
    title: t('corrections.previous_adjustment')
  }, /*#__PURE__*/React.createElement(CorrectionsDetailsTable, {
    allocationCycleId: allocationCycleId,
    handleClose: handleModalCloseExt,
    correctionSummary: correctionSummary,
    isExcluded: isExcluded
  }));
};
export default CorrectionsDetails;